import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { CtaButtonComponent } from '../../../../shared/components/ui/cta-button/cta-button.component';

@Component({
  selector: 'app-empty-course-list',
  standalone: true,
  imports: [CommonModule, TranslatePipe, CtaButtonComponent],
  templateUrl: './empty-course-list.component.html',
  styleUrl: './empty-course-list.component.scss'
})
export class EmptyCourseListComponent {
  showButton = input<boolean>(false);
  buttonClick = output<void>();

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
